
/**
 * +-------------------------------------------------+
 * |                                                 |
 * | Function Global Untuk Sweet Alert 2             |
 * +_________________________________________________+
 * 
 * Asalkan function mixin dan vue componentnya sama pagination bisa berjalan
 */

import KecamatanService from "../../services/datamaster/kecamatan.service";
import KotaKabupatenService from "../../services/datamaster/kota-kabupaten.service";
import ProvinsiService from "../../services/datamaster/provinsi.service";

export const Location = {
    data() {
      return {
        optionKecamatan : [],
        optionKotaKab : [],
        optionProvinsi : [],
        multi_kecamatan : [],
        multi_kota_kab : [],
        multi_provinsi : [],
        loading: {
          isKecamatan: true,
          isKotaKab: true,
          isProvinsi: true,
        },
      }
    },
    methods: {
      getAllKecamatan() {
        this.loading.isKecamatan = true;
        KecamatanService.getAllKecamatan()
        .then(response => {
          this.optionKecamatan = response.data.data.content            
          this.loading.isKecamatan = false;
        }).catch(error => {
          // comment console console.log(error)
          this.loading.isKecamatan = false;
        })
      },
      getAllProvinsi() {
        this.loading.isProvinsi = true;
        ProvinsiService.getAllProvinsi()
          .then(response => {
            this.optionProvinsi = response.data.data.content
            this.loading.isProvinsi = false;
          }).catch(error => {
            // comment console console.log(error)
            this.loading.isProvinsi = false;
          })
      },
      getAllKotaKab() {
        this.loading.isKotaKab = true;
        KotaKabupatenService.getAll()
          .then(response => {
            this.optionKotaKab = response.data.data.content            
            this.loading.isKotaKab = false;
          }).catch(error => {
            // comment console console.log(error)
            this.loading.isKotaKab = false;
          })
      },
    }
  };